import { toggleModal } from "@/core/reatom/state/modal/modal";
import {
  resetProfessionsDetailsAction,
  selectedCategoriesAtom,
  selectedProfessionsAtom,
  toggleProfessionsIdAction,
} from "@/core/reatom/state/search/";
import { useAction, useAtom } from "@reatom/npm-react";
import { useRef } from "react";
import { CategoryPatch } from "./category-patch/CategoryPatch";
import s from "./style.module.scss";
import Arrow from "@/assets/arrow-turned.svg?react";
import { professionIdsAtom } from "@/core/reatom/state/search/search";

export const CategoriesPatchMapper = () => {
  const [selectedCategories] = useAtom(selectedCategoriesAtom);
  const [selectedProfessions] = useAtom(selectedProfessionsAtom);
  const toggleProfessionIds = useAction(toggleProfessionsIdAction);
  const resetProfessionsDetails = useAction(resetProfessionsDetailsAction);
  const [selectedProfessionsIds] = useAtom(professionIdsAtom);

  const handleToggleModal = useAction(toggleModal);

  const wrapperRef = useRef<HTMLDivElement | null>(null);

  return (
    <div className={s.choosenCategories} ref={wrapperRef}>
      {selectedCategories &&
        selectedCategories
          .filter((_, i) => i < 3)
          .map((item) => (
            <CategoryPatch
              key={item.id}
              label={item.name}
              id={item.id}
              colorType="green"
              onRemove={() => {
                resetProfessionsDetails(item.id);
                toggleProfessionIds();
              }}
            />
          ))}
      {selectedProfessions
        .filter((_, i) => i < 3)
        .map((item) => (
          <CategoryPatch
            key={item.id}
            label={item.name}
            id={item.id}
            colorType="grey"
            onRemove={() => {
              toggleProfessionIds(item.id);
            }}
          />
        ))}
      {selectedProfessions.length > 3 && (
        <button
          className={s.openModalButton}
          onClick={() => handleToggleModal("subCategories")}
        >
          <Arrow />
        </button>
      )}
    </div>
  );
};
